import React from 'react';
export default function ProfilePictureIcon() {
    return (React.createElement("div", { className: 'revamp-user-avatar' },
        React.createElement("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "#CCCCCC" }),
            React.createElement("path", { d: "M22 25C27.5228 25 32 29.4772 32 35V36C28.6572 38.5111 24.5027 40 20 40C15.4973 40 11.3428 38.5111 8 36V35C8 29.4772 12.4772 25 18 25H22ZM20 7C24.4183 7 28 10.5817 28 15C28 19.4183 24.4183 23 20 23C15.5817 23 12 19.4183 12 15C12 10.5817 15.5817 7 20 7Z", fill: "#A2A2A9" }))));
}
